import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={10 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 10 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M0.886524 18.8297C0.93169 18.5356 1.00725 17.924 1.27571 17.3622C1.53784 16.8141 1.7911 16.6328 1.88227 16.0435C2.37614 12.8614 2.27315 12.3522 3.31449 8.54356C4.00717 6.00969 4.72041 1.13229 5.20795 1.04355C5.74909 0.945149 6.15392 5.73119 6.20795 8.54355C6.70795 12.3826 7.83162 13.5071 8.02199 15.9481C8.11148 17.0985 8.11125 17.3448 8.20792 17.6489C8.29065 17.9095 8.6826 18.2081 8.71679 18.5478C8.83202 19.6863 8.80627 22.0003 8.70792 23.5918C8.65051 24.5234 8.51333 24.9048 7.76493 24.9657C6.15248 25.0968 2.76026 25.0574 1.31412 24.8851C0.792811 24.8231 0.747223 24.4867 0.732871 23.8714C0.69868 22.3724 0.664917 20.27 0.886524 18.8297Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
